import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import PageHeader from "../../components/PageHeader";
import Button from "../../components/Button";

import PapaHead from "../../assets/papahead.svg";

const ThankYou = () => {
  useEffect(() => {
    const el = document.getElementById("app__content");
    el.classList.add("thank-you");
    return () => {
      el.classList.remove("thank-you");
    };
  }, []);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <PageHeader className="text-center">
        <div className="papa-head flex">
          <div>
            <span>Thank&nbsp;</span>
          </div>
          <div className="flex">
            <span>Y</span>
            <img src={PapaHead} alt="Papa" />
            <span>u!</span>
          </div>
        </div>

        <h1>Your application has been submitted! </h1>
        <h2>You will recieve an email shortly with further instructions</h2>

        <Button to="/">Back to home</Button>
      </PageHeader>
    </>
  );
};

export default ThankYou;
